






































import {Component, Vue, Watch} from 'vue-property-decorator'
import {appointment} from '@/store/types'
import axios from "axios";
import {MutationList as RootMutations} from "@/store/modules/root/mutation-list";
import {MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class AppointmentSelect extends Vue {

    // TODO implement query parameters checks

    // namespaces for accessing module data
    private rootNamespace = 'root/';
    private modalNamespace = 'modal/';

    // testing vars
    private doctorsList = [
        {
            "name": "Čui Gaļina",
            "address": "423432 G",
            "id": 2,
            "appointments": [
                {
                    "date": "28.01",
                    "slots": [
                        {
                            "time": "18:00",
                            "free": true,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "19:00",
                            "free": false,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "20:00",
                            "free": true,
                            "slot_id": "2hq9uh2q"
                        }
                    ]
                },
                {
                    "date": "29.01",
                    "slots": [
                        {
                            "time": "18:00",
                            "free": false,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "19:00",
                            "free": false,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "20:00",
                            "free": true,
                            "slot_id": "2hq9uh2q"
                        }
                    ]
                },
                {
                    "date": "30.01",
                    "slots": [
                        {
                            "time": "18:00",
                            "free": false,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "19:00",
                            "free": true,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "20:00",
                            "free": true,
                            "slot_id": "2hq9uh2q"
                        }
                    ]
                },
                {
                    "date": "28.01",
                    "slots": [
                        {
                            "time": "18:00",
                            "free": false,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "19:00",
                            "free": false,
                            "slot_id": "2hq9uh2q"
                        },
                        {
                            "time": "20:00",
                            "free": true,
                            "slot_id": "2hq9uh2q"
                        }
                    ]
                }
            ]
        }
    ]
    private doctorSlotList!: any;

    private showForward = true;

    // Watcher to load data when component is navigated
    // @Watch('$route', {immediate: true, deep: true})
    // async fetchData() {
    //     this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_LOADING_MODAL}`, 'Saving data');
    //     await axios.get('https://dev.palmamedical.lv/api/rest/services/list')
    //         .then(response => {
    //             this.doctorSlotList = response.data;
    //             this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_MODAL_VISIBILITY_FALSE}`);
    //         })
    //         .catch(e => {
    //             this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_MESSAGING_MODAL}`, {
    //                 header: 'an error happened',
    //                 message: e
    //             });
    //         });
    // }

    // Selecting slot + showing modals with success message
    selectSlot(doctor: string, time: string, date: string) {
        this.$store.commit(`${this.rootNamespace}${RootMutations.SAVE_APPOINTMENT}`, {
            doctor: doctor,
            date: date,
            time: time,
            institution: 'first'
        });
        this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_SMALL_MODAL}`, {
            message: `Doctor: ${doctor}, Date: ${date}, Time: ${time}`,
            title: 'Added appointment'
        });
    }

    // Forward button
    // TODO implement checks for appointment.length > 0
    forward() {
        this.$router.push('/confirmation');
    }

    // Appointment list on top of section
    get appointmentList(): appointment[] {
        return this.$store.getters[`${this.rootNamespace}getAppointmentList`];
    }
}
